export default __webpack_public_path__ + "static/media/2021-MG.0d4e7937.jpg";